import React from "react";

export const FUEL_CONTROL_HELP_TITLE = "Controle de combustível";

export function FuelControlHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> Mostra os abastecimentos e o consumo
        das máquinas assumidas no app de campo — litros, horímetro e o
        intervalo entre um tanque e outro.
      </p>
      <p>
        <strong>O que fazer:</strong> escolha operador, máquina e período
        (como no App de Campo) e confira a planilha. Cada intervalo fecha
        quando o operador informa <strong>tanque cheio</strong>.
      </p>
      <p>
        Abastecimentos parciais entram no cálculo, mas a média fica marcada
        como estimativa — sem tanque cheio não há como saber o consumo real
        do período.
      </p>
      <p>
        Se o trabalho marca hectares no painel, o operador deve informar a
        leitura no abastecimento — assim a plataforma calcula L/ha e ha/h no
        intervalo.
      </p>
      <p>
        As colunas comparam o último intervalo, a média dos três últimos e a
        média de todos os intervalos no período selecionado.
      </p>
    </>
  );
}
